module.exports = __webpack_public_path__ + "static/Image06@2x-75bee345753ed5c7dfe06bc9b4473a2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/design/photos/Image06@2x.jpg
// module id = 899
// module chunks = 227233210825294 244429959259914